import { render, staticRenderFns } from "./select-voucher-detail-type.vue?vue&type=template&id=5520133b"
import script from "./select-voucher-detail-type.vue?vue&type=script&lang=js"
export * from "./select-voucher-detail-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports